import { CameraStatus } from '@shared/models/live';

/** Returns a new list: an unknown source gets `status` itself, a known one a copy with only its flags changed. */
export function upsertCameraStatus(list: readonly CameraStatus[], status: CameraStatus): CameraStatus[] {
  const index = list.findIndex((cs) => cs.SourceId === status.SourceId);
  if (index === -1) {
    return [...list, status];
  }
  return list.map((cs, i) => (i === index ? { ...cs, IsBodyTracking: status.IsBodyTracking, IsScreenDetecting: status.IsScreenDetecting } : cs));
}
